import { MouseEvent, useCallback } from 'react';

import { ConferenceStatus } from '@yandex-360/telemost-sdk';
import { useSelector } from 'react-redux';

import { countMetrika } from '../../../../../shared/helpers/metrika';
import { getConferenceStatus } from '../../../selectors';

export function useToolbarButtonClickHandlerMaker() {
    const conferenceStatus = useSelector(getConferenceStatus);
    const isJoined = conferenceStatus === ConferenceStatus.JOINED;

    return useCallback(
        (func: (event?: MouseEvent) => void, ...metrikaParams: string[]) => {
            return (event?: MouseEvent) => {
                func(event);
                countMetrika(isJoined ? 'meeting_screen' : 'connection_screen', ...metrikaParams);
            };
        },
        [isJoined]
    );
}
